import { render, staticRenderFns } from "./ReceiptConfirmation.vue?vue&type=template&id=21bc30c0&scoped=true&"
import script from "./ReceiptConfirmation.vue?vue&type=script&lang=js&"
export * from "./ReceiptConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptConfirmation.vue?vue&type=style&index=0&id=21bc30c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bc30c0",
  null
  
)

export default component.exports